import './style.scss';

import { Menu } from 'antd';
import clsx from 'clsx';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';

import type { MenuProps } from 'antd';
import LinkRoute from '../link/LinkRoute';
import { ROOT_PAGES } from '../../routes';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group'
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const items = [
  getItem(
    <LinkRoute to={ROOT_PAGES.HOME} external>
      Home{' '}
      <div className="icon-mobile">
        <img src="/images/arr-mb.png" alt="" />
      </div>
    </LinkRoute>,
    '1',
    <>
      <LinkRoute to={ROOT_PAGES.HOME} external>
        <img src="/images/menu/home.png" alt="" />
        <img src="/images/menu/home-1.png" alt="" />
      </LinkRoute>
    </>
  ),
  getItem(
    <LinkRoute to={ROOT_PAGES.STAKING}>
      Staking 1.0
      <div className="icon-mobile">
        <img src="/images/arr-mb.png" alt="" />
      </div>
    </LinkRoute>,
    '2',
    <>
      <LinkRoute to={ROOT_PAGES.STAKING}>
        <img src="/images/menu/stake.png" alt="" />
        <img src="/images/menu/stake-2.png" alt="" />
      </LinkRoute>
    </>
  ),
  getItem(
    <LinkRoute to={ROOT_PAGES.STAKING_TOKEN} external>
      Staking 2.0
      <div className="icon-mobile">
        <img src="/images/arr-mb.png" alt="" />
      </div>
    </LinkRoute>,
    '10',
    <>
      <LinkRoute to={ROOT_PAGES.STAKING_TOKEN} external>
        <img src="/images/menu/more.png" alt="" />
        <img src="/images/menu/more-2.png" alt="" />
      </LinkRoute>
    </>
  ),
  // getItem(
  //   <LinkRoute to={ROOT_PAGES.P2P_LENDING} external>
  //     P2P Lending{' '}
  //     <div className="icon-mobile">
  //       <img src="/images/arr-mb.png" alt="" />
  //     </div>
  //   </LinkRoute>,
  //   '4',
  //   <>
  //     <LinkRoute to={ROOT_PAGES.P2P_LENDING} external>
  //       <img src="/images/menu/lending.png" alt="" />
  //       <img src="/images/menu/lending-1.png" alt="" />
  //     </LinkRoute>
  //   </>
  // ),
  // getItem(
  //   <LinkRoute to={ROOT_PAGES.PTO} external>
  //     PTO{' '}
  //     <div className="icon-mobile">
  //       <img src="/images/arr-mb.png" alt="" />
  //     </div>
  //   </LinkRoute>,
  //   '5',
  //   <>
  //     <LinkRoute to={ROOT_PAGES.PTO} external>
  //       <img src="/images/menu/pto-1.png" alt="" />
  //       <img src="/images/menu/pto.png" alt="" />
  //     </LinkRoute>
  //   </>
  // ),
  // getItem(
  //   <LinkRoute to={ROOT_PAGES.MARKETPLACE} external>
  //     Marketplace{' '}
  //     <div className="icon-mobile">
  //       <img src="/images/arr-mb.png" alt="" />
  //     </div>
  //   </LinkRoute>,
  //   '6',
  //   <>
  //     <LinkRoute to={ROOT_PAGES.MARKETPLACE} external>
  //       <img src="/images/menu/store.png" alt="" />
  //       <img src="/images/menu/store-1.png" alt="" />
  //     </LinkRoute>
  //   </>
  // ),
  // getItem(
  //   <LinkRoute to={ROOT_PAGES.HISTORY} external>
  //     History{' '}
  //     <div className="icon-mobile">
  //       <img src="/images/arr-mb.png" alt="" />
  //     </div>
  //   </LinkRoute>,
  //   '8',
  //   <>
  //     <LinkRoute to={ROOT_PAGES.HISTORY} external>
  //       <img src="/images/menu/his.png" alt="" />
  //       <img src="/images/menu/his-1.png" alt="" />
  //     </LinkRoute>
  //   </>
  // ),
  getItem(
    <LinkRoute to={ROOT_PAGES.AFFILIATES} external>
      Affiliate{' '}
      <div className="icon-mobile">
        <img src="/images/arr-mb.png" alt="" />
      </div>
    </LinkRoute>,
    'affiliate',
    <>
      <LinkRoute to={ROOT_PAGES.AFFILIATES} external>
        <img src="/images/menu/affiliate.png" alt="" />
        <img src="/images/menu/affiliate-1.png" alt="" />
      </LinkRoute>
    </>
  ),
  // getItem(
  //   <LinkRoute to={ROOT_PAGES.AIRDROP} external>
  //     Airdrop{' '}
  //     <div className="icon-mobile">
  //       <img src="/images/arr-mb.png" alt="" />
  //     </div>
  //   </LinkRoute>,
  //   '9',
  //   <>
  //     <LinkRoute to={ROOT_PAGES.AIRDROP} external>
  //       <img src="/images/air-non-active.png" alt="" />
  //       <img src="/images/air-active.png" alt="" />
  //     </LinkRoute>
  //   </>
  // ),
  getItem(
    <LinkRoute to={ROOT_PAGES.ACCOUNT} external>
      My Account{' '}
      <div className="icon-mobile">
        <img src="/images/arr-mb.png" alt="" />
      </div>
    </LinkRoute>,
    '7',
    <>
      <LinkRoute to={ROOT_PAGES.ACCOUNT} external>
        <img src="/images/menu/por.png" alt="" />
        <img src="/images/menu/por-1.png" alt="" />
      </LinkRoute>
    </>
  ),
];
const SideBar = (props: any) => {
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState<any>('1');

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const location = useLocation();

  const mapPathToKey: { [key: string]: string } = {
    [`${ROOT_PAGES.HOME}`]: '1',
    [`${ROOT_PAGES.STAKING}`]: '2',
    [`${ROOT_PAGES.STAKING_DETAIL}`]: '2',
    [`${ROOT_PAGES.P2P_LENDING}`]: '4',
    [`${ROOT_PAGES.P2P_LENDING_DETAIL}`]: '4',
    [`${ROOT_PAGES.PTO}`]: '5',
    [`${ROOT_PAGES.PAGE_PTO_DETAIL}`]: '5',
    [`${ROOT_PAGES.MARKETPLACE}`]: '6',
    [`${ROOT_PAGES.MARKETPLACE_DETAIL}`]: '6',
    [`${ROOT_PAGES.HISTORY}`]: '8',
    [`${ROOT_PAGES.AFFILIATES}`]: 'affiliate',
    [`${ROOT_PAGES.AIRDROP}`]: '9',
    [`${ROOT_PAGES.ACCOUNT}`]: '7',
    [`${ROOT_PAGES.ACCOUNT_VERIFY_EMAIL}`]: '7',
    [`${ROOT_PAGES.VESTING}`]: '7',
    [`${ROOT_PAGES.VESTING_HMC}`]: '7',
    [`${ROOT_PAGES.VESTING_VENTURE}`]: '7',
    [`${ROOT_PAGES.ACCOUNT_EDIT_PROFILE}`]: '7',
    [`${ROOT_PAGES.RANK}`]: '7',
  };

  const activeKey = mapPathToKey[location.pathname] || '1';

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
    sessionStorage.setItem('keyActiveMenu', e.key);
    if (isMobile) {
      window.location.reload();
    }
  };

  let keyActiveDrop: any;
  if (
    typeof window !== 'undefined' &&
    window.sessionStorage.getItem('keyActiveMenu') !== undefined
  ) {
    keyActiveDrop = window.sessionStorage.getItem('keyActiveMenu');
  }
  function gotoDocs() {
    window.open('https://docs.mey.network/mey-network');
  }

  const sendData = () => {
    props?.callbackFunction(collapsed);
  };

  useEffect(() => {
    sendData();
  }, [collapsed]);

  return (
    <>
      <div className="menu-wrap">
        <div className={clsx('menu-sidebar', collapsed && 'collapse-menu')}>
          {isMobile ? (
            <>
              <div className="sidebar-top sidebar-mobile">
                <LinkRoute
                  className={clsx(collapsed && 'flex justify-center')}
                  external
                  to="/"
                >
                  <img
                    className="h-7"
                    src={
                      collapsed
                        ? '/images/logo-collapse.png'
                        : '/images/logo.png'
                    }
                    alt=""
                  />
                </LinkRoute>
                <div
                  className={clsx(
                    'sidebar-icon transition',
                    !collapsed && 'rotate-180'
                  )}
                  onClick={toggleCollapsed}
                >
                  <img src="/images/icon-sidebar.png" alt="" />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="sidebar-top">
                <LinkRoute
                  className={clsx(collapsed && 'flex justify-center')}
                  external
                  to="/"
                >
                  <img
                    className="h-7"
                    src={
                      collapsed
                        ? '/images/logo-collapse.png'
                        : '/images/logo.png'
                    }
                    alt=""
                  />
                </LinkRoute>
                <div
                  className={clsx(
                    'sidebar-icon transition',
                    !collapsed && 'rotate-180'
                  )}
                  onClick={toggleCollapsed}
                >
                  <img src="/images/icon-sidebar.png" alt="" />
                </div>
              </div>
            </>
          )}
          <div className="sidebar-center">
            <Menu
              selectedKeys={[activeKey]}
              onClick={onClick}
              mode="inline"
              theme="dark"
              items={items}
            />
          </div>
          <div className="sidebar-bottom">
            <div className="row-contact">
              <div className="item" onClick={gotoDocs}>
                <img src="/images/question.png" alt="" /> <span>Docs</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
